import { range } from 'lodash';
import React from 'react';
import Skeleton from 'react-loading-skeleton';

export default function FilterBarLoading() {
  return (
    <div className="col-xl-3">
      <aside className="sidebar y-gap-20 xl:d-none">
        <div className="sidebar__item -no-border position-relative">
          <Skeleton
            className="flex-center"
            style={{
              height: '118px',
            }}
          />
        </div>
        <div className="sidebar__item -no-border">
          <Skeleton className="text-18 fw-500 mb-10"></Skeleton>
          <div className="items-center py-10">
            <Skeleton className="pl-50 border-light text-dark-1 h-50 rounded-8" style={{ width: '100%' }} />
          </div>
        </div>
        {range(0, 5).map(x => {
          return (
            <div className="sidebar__item" key={x}>
              <Skeleton className="text-18 fw-500 mb-10" />
              <div className="sidebar-checkbox">
                {range(0, 10).map(k => {
                  return (
                    <div key={k} className="row y-gap-10 items-center justify-between">
                      <div className="col-auto">
                        <div className="form-checkbox d-flex items-center">
                          <Skeleton className="" width={15} />
                          <Skeleton className="text-15 ml-10" width={`${Math.random() * 200}px`} />
                        </div>
                      </div>
                      <div className="col-auto">
                        <Skeleton className="text-15 text-light-1" width={30}></Skeleton>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </aside>
    </div>
  );
}
